import React, { FC } from 'react';
import Helmet from 'react-helmet';

interface Props {
  schema: Record<string, unknown> | Array<Record<string, unknown>>;
}

const JsonLd: FC<Props> = ({ schema }) => {
  const serialized = JSON.stringify(schema).replace(/</g, '\\u003c');

  return (
    <Helmet defer={false}>
      <script type="application/ld+json">{serialized}</script>
    </Helmet>
  );
};

export default JsonLd;
